import React from 'react';
import { Link } from 'react-router-dom';

const FeaturesList: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="md:w-1/2 text-center md:text-left">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Join the program that's helped hundreds of businesses make or save $100k+ per year using AI
            </h2>
            
            <p className="text-gray-700 text-lg mb-8">
              Our unique data, insights, AI white-label AI app team, and proven frameworks help anyone, regardless of background, even non-tech people, leverage the power of AI.
            </p>
            
            <div className="mb-8 md:mb-0">
              <Link 
                to="/contact" 
                className="bg-primary text-white px-8 py-3 rounded-md font-bold text-lg inline-block transform hover:scale-105 transition-all duration-200 uppercase animate-wiggle animate-pulse-glow"
                style={{ 
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                  animation: 'wiggle 3s ease-in-out infinite, pulse-glow 2s ease-in-out infinite'
                }}
              >
                APPLY TO BECOME A CLIENT
              </Link>
            </div>
          </div>
          
          <div className="md:w-5/12">
            <div className="transform transition-all duration-300 hover:scale-[1.02]">
              <img 
                src="/images/diagram.png.png" 
                alt="Our Lead Generation Formula" 
                className="w-full h-auto mx-auto"
                style={{ 
                  filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.15))'
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesList; 